export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-ss672tpt2sq2sqp8.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'Nu16i935YjRdKb1J8zfnf10sZaMeZldy', // Frontend SPA client
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.fitmanager.com',
  redirectUri: window.location.origin + '/callback',
  scope: 'openid profile email read:users write:users read:clients write:clients read:coaches write:coaches read:exercises write:exercises read:programs write:programs',
};

export const apiConfig = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  timeout: 10000,
}; 